import { Link } from 'react-router-dom';
import styles from './nameWithIdColumn.module.scss';
import classNames from 'classnames/bind';

export type NameWithIdColumnProps = {
  id: string | number;
  name: string;
  clickUrl?: string;
  isActive?: boolean;
};

const cx = classNames.bind(styles);

export const NameWithIdColumn = ({
  id,
  name,
  clickUrl,
  isActive,
}: NameWithIdColumnProps) => {
  const nameClass = cx('name', {
    active: isActive,
    link: !!clickUrl,
  });
  return (
    <div className={styles.info}>
      {clickUrl ? (
        <Link to={clickUrl} className={nameClass}>
          {name}
        </Link>
      ) : (
        <span className={nameClass}>{name}</span>
      )}
      <div className={styles.id}>{'ID: ' + id}</div>
    </div>
  );
};
